// extracted by mini-css-extract-plugin
export default {"formHolder":"LogInPage_formHolder__pUaY6","languageSelectorHolder":"LogInPage_languageSelectorHolder__c8cT5"};